/* eslint-disable react/no-unstable-nested-components */
import ContainedButton from "components/layout/form/containedButton";
import React, { useCallback, useState } from "react";
import TextField from "components/layout/form/textField";
import formatCnpj from "@brazilian-utils/format-cnpj";
import formatCpf from "@brazilian-utils/format-cpf";
import { FaRegUser } from "react-icons/fa";
import { Field, Formik } from "formik";
import { cpfCnpjCursorAlign } from "utils/functions";
import { isCNPJ, isCPF } from "brazilian-values";
import { toast } from "react-toastify";
import { useHistory } from "react-router-dom";
import { useQuickBillContext } from "pages/BoletoRapido/hooks/useQuickBill";

import { useGaEvents } from "pages/BoletoRapido/hooks/useGaEvents";

import {
  Container,
  ContainerButtons,
  FormContainer,
  Subtitle,
  TextWrapper,
  Title,
  Wrapper,
} from "./styles";

const FormBoletoRapido: React.FC = () => {
  const [loading, setLoading] = useState(false);
  const [dispatchErrorCpf, setDispatchErrorCpf] = useState(false);

  const { handleClickDocument, documentInvalid } = useGaEvents();

  const history = useHistory();

  const { setDocument, setStep } = useQuickBillContext();

  const validateDocument = (value: string): string => {
    let error;

    const numbers = value.replace(/[^\d]/g, "");
    if (!numbers) {
      return "É obrigatório preencher seus dados!";
    }

    if (numbers.length === 11 && !isCPF(numbers)) {
      return "Insira um CPF válido";
    }
    if (numbers.length === 14 && !isCNPJ(numbers)) {
      return "Insira um CNPJ válido";
    }
    if (
      numbers.length < 11 ||
      (numbers.length > 11 && numbers.length < 14) ||
      numbers.length > 14
    ) {
      return "Documento inválido";
    }

    return error;
  };

  const handleDocument = useCallback((event, handleChange) => {
    const cursorStart = event.target.selectionStart;
    const cursorEnd = event.target.selectionEnd;
    const numbers = event.target.value.replace(/[^\d]/g, "");

    if (numbers.length <= 11) {
      event.target.value = formatCpf(numbers);
    } else {
      event.target.value = formatCnpj(numbers);
    }

    cpfCnpjCursorAlign(event, cursorStart, cursorEnd);
    handleChange(event);
  }, []);

  const handleSubmit = useCallback(
    async ({ document }) => {
      handleClickDocument(document);
      setLoading(true);
      const numbers = document.replace(/[^\d]/g, "");
      setDocument(numbers);
      setStep(2);
      history.push("/boleto-rapido");
    },
    [setLoading]
  );

  return (
    <Wrapper>
      <Container>
        <TextWrapper>
          <Title>Boleto Rápido</Title>
          <Subtitle>Veja seus boletos de maneira rápida e eficiente.</Subtitle>
        </TextWrapper>
        <Formik
          initialValues={{
            document: "",
          }}
          onSubmit={handleSubmit}
          render={({ handleChange, handleBlur, values, errors, touched }) => {
            if (
              errors.document &&
              touched.document &&
              !dispatchErrorCpf &&
              (errors?.document === "Insira um CNPJ válido" ||
                errors?.document === "Documento inválido" ||
                errors?.document === "Insira um CPF válido")
            ) {
              setDispatchErrorCpf(true);
              documentInvalid(
                values.document,
                (errors?.document as string) ?? ""
              );
            }
            return (
              <FormContainer>
                <Field
                  validate={validateDocument}
                  name="document"
                  render={({ field }) => (
                    <TextField
                      {...field}
                      label="Insira seu CPF ou CNPJ *"
                      placeholder="Insira seu CPF ou CNPJ *"
                      errorCondition={errors.document && touched.document}
                      errorMessage={errors.document}
                      isCorrect={!errors.document}
                      value={values.document}
                      // @ts-ignore
                      LeadingIcon={() => <FaRegUser />}
                      onBlur={handleBlur}
                      onClick={() => toast.dismiss()}
                      onChange={(e) => {
                        setDispatchErrorCpf(false);
                        handleDocument(e, handleChange);
                      }}
                    />
                  )}
                />

                <ContainerButtons>
                  <ContainedButton
                    block
                    type="submit"
                    continue
                    loading={loading}
                    disabled={loading || !values.document}
                    id="Avançar"
                    width="100%"
                  >
                    2ª Via Boleto Rápido
                  </ContainedButton>
                </ContainerButtons>
              </FormContainer>
            );
          }}
        />
      </Container>
    </Wrapper>
  );
};

export default FormBoletoRapido;
